module.exports = __webpack_public_path__ + "img/rate5.3fdd29f3.png";